var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "calendar-today-wrapper", attrs: { id: "today-event" } },
    [
      _c(
        "a-popover",
        {
          attrs: {
            id: "calendarTodayEvents",
            placement: "bottom",
            trigger: "hover",
            overlayClassName: "calendarTodayEvents",
          },
        },
        [
          _vm.todayEvents.length > 0
            ? _c(
                "template",
                { slot: "content" },
                [
                  _c("div", { staticClass: "add-event-popover" }, [
                    _c(
                      "div",
                      {
                        staticClass: "material-icons add-event-btn",
                        on: { click: _vm.openAddEvent },
                      },
                      [_vm._v("add")]
                    ),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.$t("calendar.addEvent")))]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.todayEvents, function (todayEvent) {
                    return _c(
                      "div",
                      {
                        key: todayEvent._id,
                        staticClass: "calendar-event event-popover",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "event-summary",
                            on: {
                              click: function ($event) {
                                return _vm.goCalendarPage(todayEvent)
                              },
                            },
                          },
                          [_vm._v(_vm._s(todayEvent.summary))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "event-date",
                            on: {
                              click: function ($event) {
                                return _vm.goCalendarPage(todayEvent)
                              },
                            },
                          },
                          [
                            _c("div", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.getEventTime(
                                      todayEvent.start,
                                      todayEvent.isAllDay
                                    )
                                  ) +
                                  " -\n                        " +
                                  _vm._s(
                                    _vm.getEventTime(
                                      todayEvent.end,
                                      todayEvent.isAllDay
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "calendar-today-button",
              on: { click: _vm.goCalendarPage },
            },
            [
              _c(
                "div",
                { staticClass: "calendar-icon-wrapper" },
                [_c("CalendarIcon")],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "calendar-date-info" }, [
                _c("span", { staticClass: "calendar-day-name" }, [
                  _vm._v(_vm._s(_vm.getFullDayString())),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "calendar-day-number" }, [
                  _vm._v(_vm._s(new Date().getDate())),
                ]),
              ]),
              _vm._v(" "),
              _vm.todayEvents.length > 0
                ? _c("div", { staticClass: "calendar-event-count" }, [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v("event_note"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.todayEvents.length))]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "calendar-add-btn",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.openAddEvent.apply(null, arguments)
                    },
                  },
                },
                [_c("div", { staticClass: "material-icons" }, [_vm._v("add")])]
              ),
            ]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.openCalendarAddEventModal
        ? _c("CreateEventModal", {
            on: {
              close: function ($event) {
                _vm.openCalendarAddEventModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }